export const liveBetStatusOptions = [
  { label: 'All tickets', value: 'all' },
  { label: 'Live', value: 'live' },
  { label: 'Settled', value: 'settled' },
]

export const liveBetsDemo = [
  {
    id: 'LB-240912-001',
    placedAt: '2025-10-16T13:25:00Z',
    user: 'swifttrader',
    type: 'Single',
    stake: 220,
    potential: 510,
    status: 'live',
    channel: 'mobile',
  },
  {
    id: 'LB-240912-002',
    placedAt: '2025-10-16T13:32:00Z',
    user: 'pixelshift',
    type: 'Parlay 4',
    stake: 75,
    potential: 1340,
    status: 'live',
    channel: 'web',
  },
  {
    id: 'LB-240912-003',
    placedAt: '2025-10-16T13:37:00Z',
    user: 'acehunter',
    type: 'Parlay 6',
    stake: 40,
    potential: 2190,
    status: 'live',
    channel: 'mobile',
  },
  {
    id: 'LB-240912-004',
    placedAt: '2025-10-16T12:58:00Z',
    user: 'lumenwave',
    type: 'Single',
    stake: 180,
    potential: 305,
    status: 'settled',
    result: 'won',
    channel: 'web',
  },
  {
    id: 'LB-240912-005',
    placedAt: '2025-10-16T12:20:00Z',
    user: 'annalytics',
    type: 'Parlay 3',
    stake: 120,
    potential: 640,
    status: 'settled',
    result: 'lost',
    channel: 'api',
  },
  {
    id: 'LB-240912-006',
    placedAt: '2025-10-16T12:41:00Z',
    user: 'fieldvision',
    type: 'Parlay 8',
    stake: 55,
    potential: 3820,
    status: 'live',
    channel: 'mobile',
  },
  {
    id: 'LB-240912-007',
    placedAt: '2025-10-16T11:57:00Z',
    user: 'oddgreen',
    type: 'Single',
    stake: 500,
    potential: 910,
    status: 'settled',
    result: 'won',
    channel: 'retail',
  },
  {
    id: 'LB-240912-008',
    placedAt: '2025-10-16T13:41:00Z',
    user: 'sidedash',
    type: 'Parlay 2',
    stake: 145,
    potential: 420,
    status: 'live',
    channel: 'web',
  },
  {
    id: 'LB-240912-009',
    placedAt: '2025-10-16T12:11:00Z',
    user: 'cornerflag',
    type: 'Parlay 12',
    stake: 25,
    potential: 9875,
    status: 'settled',
    result: 'cash out',
    channel: 'mobile',
  },
  {
    id: 'LB-240912-010',
    placedAt: '2025-10-16T13:47:00Z',
    user: 'microedge',
    type: 'Single',
    stake: 260,
    potential: 455,
    status: 'live',
    channel: 'api',
  },
]

export const largeBetAlertsDemo = [
  {
    id: 'LBA-001',
    placedAt: '2025-10-16T13:22:00Z',
    user: 'oddgreen',
    stake: 500,
    type: 'Single',
    potential: 910,
    status: 'settled',
  },
  {
    id: 'LBA-002',
    placedAt: '2025-10-16T13:33:00Z',
    user: 'midnightimagine',
    stake: 800,
    type: 'Parlay 5',
    potential: 4680,
    status: 'live',
  },
  {
    id: 'LBA-003',
    placedAt: '2025-10-16T13:41:00Z',
    user: 'stormpilot',
    stake: 720,
    type: 'Parlay 7',
    potential: 5720,
    status: 'live',
  },
  {
    id: 'LBA-004',
    placedAt: '2025-10-16T12:58:00Z',
    user: 'lumenwave',
    stake: 600,
    type: 'Single',
    potential: 1010,
    status: 'settled',
  },
]

export const bettingTotals = {
  singleTickets: 428,
  parlayTickets: 219,
  exposure: 167500,
  avgStake: 142,
}

export const parlayTotals = [
  { size: 2, total: 58 },
  { size: 3, total: 46 },
  { size: 4, total: 39 },
  { size: 5, total: 27 },
  { size: 6, total: 21 },
  { size: 7, total: 15 },
  { size: 8, total: 12 },
  { size: 9, total: 8 },
  { size: 10, total: 5 },
  { size: 11, total: 3 },
  { size: 12, total: 2 },
]

export const autoRefreshIntervals = [
  { label: 'Disabled', value: 0 },
  { label: '15 seconds', value: 15 },
  { label: '30 seconds', value: 30 },
  { label: '1 minute', value: 60 },
]
